<script setup>
import {computed, reactive, ref} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "@/router/index.js";

/*搜索功能*/
// 表单数据
const formData = reactive({
  qrCodeNo: "",
  createTime: []
})

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 表格加载状态
const loading = ref(false)
// 当前选择的标签卡
const tab = ref("all")

// 表格headers
const headers = [
  { title: "二维码编号", key: "qrCodeNo", align: "center", nowrap: true },
  { title: "绑定车辆", key: "bindBicycle", align: "center", nowrap: true },
  { title: "绑定状态", key: "bindStatus", align: "center", nowrap: true },
  { title: "二维码生成时间", key: "createTime", align: "center", nowrap: true },
  { title: "操作", key: "controls", align: "center", minWidth: "160px", fixed: true },
]

// 表格静态数据
const qrCodeList = ref([
  {
    qrCodeNo: "QM0001",
    bindBicycle: "捷安特-Alight1-黑色",
    bindStatus: "已绑定",
    createTime: "2026-06-12 12:06:12",
    isBound: true,
  },
  {
    qrCodeNo: "QM0002",
    bindBicycle: "品牌名称-车辆型号-黄色",
    bindStatus: "已绑定",
    createTime: "2026-06-12 12:06:12",
    isBound: true,
  },
  {
    qrCodeNo: "QM0003",
    bindBicycle: "—",
    bindStatus: "未绑定",
    createTime: "2026-06-12 12:06:12",
    isBound: false,
  },
])

// 根据标签卡筛选表格数据
const tableData = computed(() => {
  if (tab.value === "bound") return qrCodeList.value.filter((item) => item.isBound)
  if (tab.value === "unbound") return qrCodeList.value.filter((item) => !item.isBound)
  return qrCodeList.value
})

// 翻页总条数
const total = computed(() => {
  if (tab.value === "bound") return 60
  if (tab.value === "unbound") return 40
  return 100
})

// 根据绑定状态获取文本类型
const getBindStatusTextType = (status) => {
  if (status === "已绑定") return "success"
  if (status === "未绑定") return "warning"
  return "default"
}

/*二维码批量生成弹窗*/
// 弹窗开关
const openCreateQRCodeDialog = ref(false)
// 弹窗表单锚点
const createQRCodeDialogFormRef = ref()
// 弹窗表单数据
const createQRCodeDialogForm = reactive({
  qrCodePrefix: "",
  qrCodeStartNo: "",
  qrCodeQuantity: "",
})
// 弹窗表单校验规则
const createQRCodeDialogRules = {}

/*操作功能*/
// 处理生成二维码
const handleCreateQRCode = () => {
  openCreateQRCodeDialog.value = true
}
// 处理导出二维码图片
const handleExportQRCode = () => {}
// 处理导出表单
const handleExportList = () => {}
// 处理下载二维码
const handleDownload = () => {}
// 处理查看详情
const handleDetail = (item) => {
  router.push({
    path: "/detailBicycleQRCode",
    query: {
      qrCodeNo: item.qrCodeNo
    }
  })
}
// 处理绑定/解绑二维码
const handleBindChange = () => {}
// 处理跳转绑定车辆
const handleBindQRCode = (item) => {
  router.push({
    path: "/bicycleQRCodeBind",
    query: {
      qrCodeNo: item.qrCodeNo
    }
  })
}
// 处理批量绑定车辆
const handleBatchBindBicycle = () => {
  router.push({
    path: "/bicycleQRCodeBind"
  })
}
// 处理关闭二维码批量生成弹窗
const handleCloseCreateQRCodeDialog = () => {
  openCreateQRCodeDialog.value = false
  createQRCodeDialogForm.qrCodePrefix = ""
  createQRCodeDialogForm.qrCodeStartNo = ""
  createQRCodeDialogForm.qrCodeQuantity = ""
  createQRCodeDialogFormRef.value?.clearValidate()
}
// 处理确认只生成二维码
const handleOnlyCreateQRCode = () => {}
// 处理确认并同时绑定车辆
const handleCreateAndBindBicycle = () => {}
// 翻页
const handleChangePage = () => {}

// 根据表单搜索信息
const handleSearch = () => {
  YTTablePaginationRef.value?.resetPage()
}

// 清空表单内容
const handleReset = () => {
  formData.qrCodeNo = ""
  formData.createTime = []
  handleSearch()
}

// 处理切换标签卡
const handleTabChange = () => {
  YTTablePaginationRef.value?.resetPage()
}
</script>

<template>
  <div class="container_box mg_b_2 qr-toolbar">
    <div class="flex_left">
      <v-btn color="success" @click="handleCreateQRCode">生成二维码</v-btn>
    </div>
  </div>

  <div class="container_box mg_b_2 qr-search-box">
    <el-form :model="formData" class="qr-search-form" label-position="left">
      <el-form-item label="二维码编号：">
        <el-input
            v-model="formData.qrCodeNo"
            class="qr-code-input"
            placeholder="二维码编号"
            clearable
        />
      </el-form-item>
      <el-form-item label="二维码生成时间：">
        <el-date-picker
            v-model="formData.createTime"
            class="qr-date-picker"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
        />
      </el-form-item>
      <div class="qr-search-actions">
        <v-btn color="success" size="large" @click="handleSearch">搜索</v-btn>
        <v-btn size="large" @click="handleReset">重置</v-btn>
      </div>
    </el-form>
  </div>

  <div class="container_box qr-table-box">
    <v-row justify="center">
      <v-col cols="11">
        <div class="qr-table-tools">
          <v-tabs
              v-model="tab"
              color="primary"
              @update:modelValue="handleTabChange"
          >
            <v-tab value="all">全部</v-tab>
            <v-tab value="bound">已绑定</v-tab>
            <v-tab value="unbound">未绑定</v-tab>
          </v-tabs>
          <div class="qr-export-actions">
            <v-btn v-if="tab === 'unbound'" color="primary" @click="handleBatchBindBicycle">绑定车辆</v-btn>
            <v-btn color="success" @click="handleExportQRCode">导出二维码</v-btn>
            <v-btn color="success" @click="handleExportList">导出表单</v-btn>
          </div>
        </div>

        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="20"
            :no-data-text="'没有更多数据了'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@3"></v-skeleton-loader>
          </template>

          <template v-slot:item.bindStatus="{ item }">
            <el-text :type="getBindStatusTextType(item.bindStatus)">
              {{ item.bindStatus }}
            </el-text>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="qr-controls">
              <el-link type="primary" :underline="false" @click="handleDownload(item)">下载</el-link>
              <span class="qr-control-divider">|</span>
              <el-link type="primary" :underline="false" @click="handleDetail(item)">详情</el-link>
              <span class="qr-control-divider">|</span>
              <el-popconfirm
                  v-if="item.isBound"
                  @confirm="handleBindChange(item)"
                  :title="`确定解绑二维码“${item.qrCodeNo}”吗？`"
              >
                <template #reference>
                  <el-link type="primary" :underline="false">解绑</el-link>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="#796CB4" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-link
                  v-else
                  type="primary"
                  :underline="false"
                  @click="handleBindQRCode(item)"
              >
                绑定
              </el-link>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination
                ref="YTTablePaginationRef"
                :total="total"
                @page-change="handleChangePage"
            ></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>

  <el-dialog
      v-model="openCreateQRCodeDialog"
      width="520"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div class="yt_dialog_title" style="padding-bottom: 30px">二维码批量生成</div>
    </template>
    <div class="yt_dialog_container">
      <el-form
          ref="createQRCodeDialogFormRef"
          style="max-width: 385px;"
          :model="createQRCodeDialogForm"
          :rules="createQRCodeDialogRules"
          class="demo-ruleForm"
          status-icon
          id="createQRCodeDialogForm"
      >
        <el-form-item label="二维码前缀：" prop="qrCodePrefix">
          <el-input
              v-model="createQRCodeDialogForm.qrCodePrefix"
              style="width: 271px"
              maxlength="3"
              show-word-limit
              placeholder="最多3位，只能包含字母、数字"
          />
        </el-form-item>
        <el-form-item label="二维码起始数：" prop="qrCodeStartNo">
          <el-input
              v-model="createQRCodeDialogForm.qrCodeStartNo"
              style="width: 271px"
              placeholder="例如001"
          />
        </el-form-item>
        <el-form-item label="输入生成数量：" prop="qrCodeQuantity">
          <div class="flex_left">
            <el-input-number
                v-model="createQRCodeDialogForm.qrCodeQuantity"
                style="width: 235px"
                :min="0"
                :step="1"
                :precision="0"
                controls-position="right"
                placeholder="请输入数量"
            />
            <span class="qr-dialog-unit">个</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="yt_dialog_footer">
        <v-btn variant="elevated" @click="handleCloseCreateQRCodeDialog">取消</v-btn>
        <v-btn class="mg_l_2" color="primary" variant="elevated" @click="handleOnlyCreateQRCode">确认只生成二维码</v-btn>
        <v-btn class="mg_l_2" color="primary" variant="elevated" @click="handleCreateAndBindBicycle">确认并同时绑定车辆</v-btn>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.qr-toolbar {
  padding: 24px 44px;
  text-align: left;
}

.qr-search-box {
  padding: 30px 44px;
  text-align: left;
}

.qr-search-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px 54px;
  width: 100%;
}

.qr-search-form :deep(.el-form-item) {
  margin: 0;
}

.qr-code-input {
  width: 230px;
}

.qr-date-picker {
  width: 460px;
}

.qr-search-actions {
  display: flex;
  gap: 24px;
  margin-left: auto;
}

.qr-table-box {
  min-height: 720px;
  padding-top: 24px;
}

.qr-table-tools {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.qr-export-actions {
  display: flex;
  gap: 4px;
  padding-bottom: 8px;
}

.qr-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.qr-control-divider {
  color: #8ea0ff;
}

.yt_dialog_title {
  padding: 20px 0 17px 33px;
  font-weight: 500;
  font-size: 19px;
  color: #272539;
  text-align: left;
}

/*弹窗内容*/
.yt_dialog_container {
  padding-left: 33px;
  text-align: left;
  ::v-deep(.el-select__wrapper),
  ::v-deep(.el-input__wrapper) {
    height: 34px;
    font-size: 12px;
    color: #6F717D;
    background: #FFFFFF;
    border-radius: 9px;
    border: 1px solid #E8E8E9;
  }
}

.yt_dialog_footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0 33px 33px 0;
}

.qr-dialog-unit {
  margin-left: 8px;
  color: #272539;
}

</style>
